import React from 'react'
import InputCustom from './input/InputCustom'
import CheckboxCustom from "./checkbox/CheckboxCustom";
import Textarea from "./textArea/TextArea";
import SelectCustom2 from "./select2/Select2";
import RangeSteps from "./range/RangeSteps";
import {formControlTypes} from "./models/formControlTypes";
import {FormControlCustomPropsModel} from "./models/FormModule";
import RadioCustom from "./radio/RadioCustom";
import Checkbox from "./checkbox/Checkbox";

const FormControlCustom = ({
                               isSubmit,
                               errors,
                               value,
                               changeValue = () => {
                               },
                               structure,
                               onBlur,
                               dataForm
                           }: FormControlCustomPropsModel) => {
    const dataElement = structure?.dataElement || {}

    return (
        <>
            {structure.type === formControlTypes.input && (
                <InputCustom
                    name={structure.name}
                    error={isSubmit && !!errors && !!errors[structure.name]}
                    extra={structure.extra}
                    value={dataForm[structure.name] || ''}
                    changeValue={(val) =>
                        changeValue({name: structure.name, value: val})
                    }
                    onBlur={onBlur}
                    {...dataElement}
                />
            )}
            {structure.type === formControlTypes.select && (
                <SelectCustom2
                    options={structure.options}
                    value={dataForm[structure.name]}
                    defaultValue={structure.defaultValue}
                    changeValue={(val: any) =>
                        changeValue({name: structure.name, value: val})
                    }
                    multiple={structure.multiple}
                    error={isSubmit && !!errors && !!errors[structure.name]}
                    {...dataElement}
                />
            )}
            {structure.type === formControlTypes.radio && (
                <RadioCustom
                    name={structure.name}
                    value={dataForm[structure.name]}
                    changeValue={(val) =>
                        changeValue({name: structure.name, value: val})
                    }
                    options={structure.options}
                    format={structure.format}
                    {...dataElement}
                />
            )}
            {structure.type === formControlTypes.textarea && (
                <Textarea
                    name={structure.name}
                    value={dataForm[structure.name]}
                    onBlur={onBlur}
                    {...dataElement}
                    changeValue={(val) =>
                        changeValue({name: structure.name, value: val})
                    }
                    error={isSubmit && !!errors && !!errors[structure.name]}
                />
            )}
            {structure.type === formControlTypes.checkbox && (
                <CheckboxCustom
                    name={structure.name}
                    value={dataForm[structure.name] || []}
                    changeValue={(val) =>
                        changeValue({name: structure.name, value: val})
                    }
                    options={structure.options}
                    format={structure.format}
                    {...dataElement}
                />
            )}
            {structure.type === formControlTypes.checkboxSingle && (
                <Checkbox
                    name={structure.name}
                    value={dataForm[structure.name] || []}
                    onChange={(e) =>
                        changeValue({name: structure.name, value: e.target.checked})
                    }
                    format={structure.format}
                    {...dataElement}
                />
            )}
            {structure.type === formControlTypes.range && (
                <RangeSteps
                    value={dataForm[structure.name]}
                    changeValue={(val) =>
                        changeValue({name: structure.name, value: val})
                    }
                    {...dataElement}
                />
            )}
            {structure.type === formControlTypes.color && (
                <input
                    type="color"
                    name={structure.name}
                    value={dataForm[structure.name]}
                    onChange={(e) =>
                        changeValue({name: structure.name, value: e.target.value})
                    }
                />

            )}

            {/*{typeElement === "progress" && (*/}
            {/*  <Progress*/}
            {/*    value={value}*/}
            {/*    changeProgress={(event: React.ChangeEvent<HTMLInputElement>) => {*/}
            {/*      changeValue(event.target.value);*/}
            {/*    }}*/}
            {/*  />*/}
            {/*)}*/}
            {/*{typeElement === "switch" && (*/}
            {/*  <Switch*/}
            {/*    className="ml-auto"*/}
            {/*    error={isSubmit && !!errors && !!errors[name]}*/}
            {/*    name={name}*/}
            {/*    checked={value}*/}
            {/*    typeCheck={dataElement?.type}*/}
            {/*    changeSwitch={(event: React.ChangeEvent<HTMLInputElement>) => {*/}
            {/*      changeValue(dataElement && dataElement.type === 'checkbox'*/}
            {/*          ? event.target.checked*/}
            {/*          : event.target.value);*/}
            {/*    }}*/}
            {/*  ></Switch>*/}
            {/*)}*/}
        </>
    )
}

export default FormControlCustom
